import React from "react";
import "./LogoutPopup.css"; // Ensure this CSS file is included

const LogoutPopup = ({ onConfirm, onClose }) => {
    return (
        <div className="popup-overlay">
            <div className="popup-box">
                <div className="popup-title">Confirmation</div>
                <div className="popup-message">Are you sure you want to log out?</div>
                <div className="popup-actions">
                    <button className="confirm-btn" onClick={onConfirm}>Yes, Logout</button>
                    <button className="cancel-btn" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default LogoutPopup;
